export enum Environment {
  Local = 'local',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}

export enum DistributionPlatform {
  Ldt = 'ldt',
  Samd = 'samd',
  Clin = 'clin',
}

export enum Region {
  US = 'us',
  EU = 'eu',
  AU = 'au',
  UK = 'uk',
  SG = 'sg',
}

export enum RepoBackend {
  Fake = 'fake',
  Real = 'real',
}
